import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { KBarWrapper } from "../components/command-bar";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <KBarWrapper>
      <App />
    </KBarWrapper>
  </StrictMode>
);
